<template>
    <div>
        <div v-if="loading" class="loading"/>

        <div class="top-right-button-container">
            <b-button v-b-modal.facility_form @click="edit = false" variant="primary" size="sm" class="top-right-button"
                      v-text="'ADD NEW'"/>
        </div>

        <div class="d-flex flex-row">
            <span class="iconsminds-building mr-3 menu-icon-style" style="font-size: 23px;"/>

            <piaf-breadcrumb heading="Facilities"/>

<!--            <p class="my-auto">-->
<!--                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi dolores quod,-->
<!--                repellendus similique sint. Ad, corporis culpa delectus est in ipsum laboriosam nostrum-->
<!--                officiis quia quos rem totam vitae.-->
<!--            </p>-->
        </div>

        <div class="my-2">
            <div class="d-block d-md-inline-block pt-1">
                <b-dropdown :text="'Order by: ' + meta.order_by"
                            variant="outline-dark" class="mr-1 float-md-left btn-group" size="xs">

                    <b-dropdown-item v-for="(field,index) in table_fields.slice(0, -1)"
                                     v-if="field.sortable === true" :key="index"
                                     @click="changeOrderBy(field.key, field.label)">{{ field.label }}
                    </b-dropdown-item>
                </b-dropdown>

                <div class="search-sm d-inline-block float-md-left ml-1 align-top">
                    <b-input placeholder="Search" @input="searchFacility" v-model="meta.search"/>
                </div>
            </div>

            <div class="float-md-right pt-1">
                <span class="text-muted text-small mr-1 mb-2">{{meta.from}}-{{meta.to}} of {{ meta.total }}</span>

                <b-dropdown right :text="meta.per_page.toString()" variant="outline-dark"
                            class="d-inline-block" size="xs">
                    <b-dropdown-item v-for="(size,index) in meta.page_sizes" :key="index"
                                     @click="changePageSize(size)">{{ size }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>

        <div class="separator mb-4"></div>

        <b-card class="mb-4" :title="'List of Facilities'">
            <b-refresh-button class="text-data-link" @click="refreshData"/>

            <b-table :key="tableKey" show-empty no-sort-reset class="vuetable" :sort-by="meta.sort_by"
                     :sort-desc="meta.sort_desc" @sort-changed="changeSorting" :per-page="meta.per_page"
                     :current-page="meta.current_page" :fields="table_fields" :items="fetchFacilities">

                <template v-slot:cell(code)="data">
                    <span v-text="data.item.data.attributes.code"/>
                </template>

                <template v-slot:cell(name)="data">
                    <router-link class="text-data-link" :to="data.item.links.self"
                                 v-text="data.item.data.attributes.name"/>
                </template>

                <template v-slot:cell(rate)="data">
                    <span v-text="data.item.data.attributes.rate"/>
                </template>

                <template v-slot:cell(vendor)="data">
                    <span v-text="data.item.data.attributes.vendor"/>
                </template>

                <template v-slot:cell(total_units)="data">
                    <span v-text="data.item.data.attributes.total_units"/>
                </template>

                <template v-slot:cell(actual_units)="data">
                    <span v-text="data.item.data.attributes.actual_units"/>
                </template>

                <template v-slot:cell(currently_occupied)="data">
                    <span v-text="data.item.data.attributes.currently_occupied"/>
                </template>

                <template v-slot:cell(type)="data">
                    <span v-text="data.item.data.attributes.type"/>
                </template>

                <template v-slot:cell(status)="data">
                    <b-badge pill style="width: 58px;"
                             :variant="facilityStatusColor(data.item.data.attributes.status)">
                        {{ data.item.data.attributes.status }}
                    </b-badge>
                </template>

                <template v-slot:cell(actions)="data">
                    <b-dropdown variant="empty" class="my-auto dropright" size="xs"
                                menu-class="mt-2" style="width: 75px;" right no-caret>
                        <template slot="button-content">
                            <i class="btn-circle simple-icon-options-vertical"/>
                        </template>

                        <b-dropdown-item :to="data.item.links.self">
                            Summary
                        </b-dropdown-item>

                        <b-dropdown-item @click="changeStatus(data.item)">
                            Change Status
                        </b-dropdown-item>

                        <b-dropdown-item @click="editFacility(data.item.facility_id)">
                            Edit
                        </b-dropdown-item>

                        <b-dropdown-item @click="deleteFacility(data.item)">
                            Delete
                        </b-dropdown-item>
                    </b-dropdown>
                </template>
            </b-table>

            <b-pagination size="sm" align="center" :total-rows="meta.total" :per-page="meta.per_page"
                          v-model="meta.current_page">
                <template v-slot:next-text>
                    <i class="simple-icon-arrow-right"/>
                </template>

                <template v-slot:prev-text>
                    <i class="simple-icon-arrow-left"/>
                </template>

                <template v-slot:first-text>
                    <i class="simple-icon-control-start"/>
                </template>

                <template v-slot:last-text>
                    <i class="simple-icon-control-end"/>
                </template>
            </b-pagination>
        </b-card>

        <FacilityFormModal :edit="edit" @updated="tableKey++"/>

        <FacilityOtherModal v-if="facility" :facility="facility" mode="status" :current-status="currentStatus" @updated="handleStatusUpdate"/>

        <FacilityDeleteModal v-if="facility" mode="facility" :facility="facility" @deleted-facility="tableKey++"/>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import FacilityFormModal from "./modals/FacilityFormModal";
    import FacilityOtherModal from "./modals/FacilityOtherModal";
    import FacilityDeleteModal from "./modals/FacilityDeleteModal";

    export default {
        name: "FacilitiesList",
        components: {
            FacilityFormModal,
            FacilityOtherModal,
            FacilityDeleteModal,
        },
        data() {
            return {
                loading: true,
                tableKey: 0,
                edit: false,
                facility: null,
                currentStatus: '',
            }
        },
        computed: {
            ...mapGetters({
                table_fields: 'getFacilityTableFields',
                meta: 'getFacilitiesMeta',
            }),
        },
        methods: {
            editFacility(facility_id) {
                this.edit = true;

                this.$store.dispatch('fetchEditFacility', facility_id)
                    .finally(response => {
                        this.$bvModal.show('facility_form');
                    });
            },

            async changeStatus(facility) {
                this.facility = facility;

                await this.$store.dispatch('fetchFacility', facility.facility_id);
                this.currentStatus = this.facility.data.attributes.status;

                setTimeout(() => {
                    this.$bvModal.show('facility_other');
                }, 1);
            },

            handleStatusUpdate(newStatus) {
                this.tableKey++
                this.currentStatus = newStatus;
            },

            deleteFacility(facility) {
                this.facility = facility;

                setTimeout(() => {
                    this.$bvModal.show('facility_delete');
                }, 1);
            },

            changeSorting(event) {
                (event.sortDesc ? this.meta.sort = 'desc' : this.meta.sort = 'asc') && (this.meta.sort_by = event.sortBy);
            },

            changeOrderBy(key, label) {
                this.meta.order_by = label;
                this.meta.sort_by = key;
            },

            changePageSize(per_page) {
                this.meta.per_page = per_page;
            },

            searchFacility: _.debounce(function (event) {
                // if (this.meta.search && this.meta.search.length >= 3) {
                    this.meta.current_page === 1 ? this.tableKey++ : this.meta.current_page = 1;
                // }
            }, 300),

            refreshData() {
                this.$store.commit('resetFacilitiesMeta');
                this.meta.current_page === 1 ? this.tableKey++ : this.meta.current_page = 1;
            },

            fetchFacilities() {
                return this.$store.dispatch('fetchFacilities')
                    .then(facilities => {
                        return facilities.data;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            facilityStatusColor: status => {
                if (status === 'Active') return 'info'
                else if (status === 'Inactive') return 'danger'
                else if (status === 'Offline') return 'warning'
            },
        }
    }
</script>

<style scoped>

</style>
